import dayjs from "dayjs";
import {buildRequest} from "./http";

/**
 * Only use this function after a user has successfully and fully logged in
 * This helper is called/paired with the userSlice action setLogout()
 *
 * @returns {Promise<void>}
 */
const logout = async () => {
    // First try B/E logout route.
    try {
        document.cookie = `is_authenticated=0`
        await processLogout();
    } catch (error) {
        // Just silently fail, if logout fails there's really not much we can do.
    } finally {
        performClientLogoutTasks();
    }
};

const performClientLogoutTasks = () => {
    clearLocalTokens();
};

const processLogout = async () => {
    const expireSessionUrl = window.env.BACKEND_API_URL + '/logout';

    try {
        const requestPromise = buildRequest(expireSessionUrl, {method: 'POST'});

        const response = await requestPromise;

        if (response.ok) {
            const responseText = await response.text();

            // Handle response without body
            return responseText ? JSON.parse(responseText) : responseText;
        }

    } catch (error) {
        throw error;
    }
};

/**
 * Clears local cookie to log the user out. Only local at the dayjs
 */
const clearLocalTokens = () => {
    const expiry = encodeURIComponent(dayjs().subtract(1, 'days').utc());
    // path is necessary here because default is current path, cookies with diff paths will be treated as diff cookies
    document.cookie = `id=;path=/;expires=${expiry}`;
    document.cookie = `profile_hash=;path=/;expires=${expiry}`;
    document.cookie = `access_token=;path=/;expires=${expiry}`;
    document.cookie = `refresh_token=;path=/;expires=${expiry}`;
};

/**
 * Manipulate cookie string to cookies object
 *
 * @returns {access_token: string | null} object of cookie name, cookie value
 */
const cookieToObject = () => {
    const cookies = document.cookie.split('; ');
    const cookieObject = {access_token: null};

    cookies.forEach(cookie => {
        const cookieKeyValue = cookie.split('=');
        const key = cookieKeyValue[0];
        let value = cookieKeyValue[1];

        if (!isNaN(value)) {
            // Set number values if they exist.
            value = Number(value);
        }

        cookieObject[key] = value;
    });

    return cookieObject;
};

export {
    cookieToObject,
    clearLocalTokens,
    logout,
    performClientLogoutTasks,
};
